import 'css-chunksrc/client/scenes/transferProjectResourceAllocations/list/task/styles.scss';export default {
  "main": "_main_ih5k7_1",
  "header": "_header_ih5k7_6",
  "iconBox": "_iconBox_ih5k7_18",
  "icon": "_icon_ih5k7_18",
  "openedIcon": "_openedIcon_ih5k7_34",
  "avatar": "_avatar_ih5k7_38",
  "col": "_col_ih5k7_43",
  "name": "_name_ih5k7_52",
  "profession": "_profession_ih5k7_61",
  "selected": "_selected_ih5k7_66"
};